import { render, staticRenderFns } from "./ClientDComponent.vue?vue&type=template&id=a16ad8d6&"
import script from "./ClientDComponent.vue?vue&type=script&lang=js&"
export * from "./ClientDComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports